module.exports = {
  src: __webpack_public_path__ + "static/media/commercial_00036_thumb.688fea61.jpg",
  width: 300,
  height: 300,
  bytes: 14214,
  type: "jpg",
};
module.exports.toString = function() {
  return __webpack_public_path__ + "static/media/commercial_00036_thumb.688fea61.jpg";
};


//////////////////
// WEBPACK FOOTER
// ./src/core/images/galleries/commercial/commercial_00036_thumb.jpg
// module id = 302
// module chunks = 0